/**
 * AddressInfo Component
 * --
 * 작성자 - Owen
 * 작성일 - 2025 07 01 화요일
 * 마지막 수정일 - 2025 07 01 화요일
 */
import React from 'react';
import { Content, Text, Row, Col, Title, ModalLayout } from 'components';
import { Button, Input, Select, Radio } from 'antd';
import { useNavigate } from 'react-router-dom';

const DELIVERY_REQUEST = [
  {
    label: '문 앞에 놔주세요',
    value: '문 앞에 놔주세요',
  },
  {
    label: '경비실에 맡겨주세요',
    value: '경비실에 맡겨주세요',
  },
  {
    label: '택배함에 넣어주세요',
    value: '택배함에 넣어주세요',
  },
  {
    label: '배송 전에 연락 주세요',
    value: '배송 전에 연락 주세요',
  },
  {
    label: '직접입력',
    value: null,
  },
];

const AddressInfo = (props) => {
  /**
   * SECTION - Init
   */
  const navigate = useNavigate();

  /**!SECTION - Init */

  /**
   * SECTION - Route
   */

  /**!SECTION - Route */

  /**
   * SECTION - Props
   */
  const {
    styles = {},
    selectedDelivery = {},
    onSelect = {},
    user = {},
    onOpen,
    deliveryAddress = [],
    onDelete,
  } = props;
  /**!SECTION - Props */

  /**
   * SECTION - Route
   */

  /**!SECTION - Route */

  /**
   * SECTION - Variable
   */

  /**!SECTION - Variable */

  /**
   * SECTION - Query Data
   */

  /**!SECTION - Query Data */

  /**
   * SECTION - Mutate
   */

  /**!SECTION - Mutate */

  /**
   * SECTION - State
   */
  // 배송지 모달
  const [isOpened, setIsOpened] = React.useState(false);
  // 베송 요청 사항
  const [selectedRequest, setSelectedRequest] = React.useState('');
  // 주소 모달
  const [selectedAddress, setSelectedAddress] = React.useState(
    selectedDelivery ?? {}
  );
  /**!SECTION - State */

  /**
   * SECTION - Function
   */

  /**!SECTION - Function */

  /**
   * SECTION - Hooks
   */

  /**!SECTION - Hooks */

  /**
   * SECTION - Render
   */
  return (
    <React.Fragment>
      {/* SECTION: 배송지 */}
      <Content
        maxWidth={'100%'}
        padding={'20px 0px'}
        style={{
          borderBottom: '1px solid var(--light-gray-color)',
        }}
      >
        <ul>
          <li style={{ ...styles.form }}>
            <div style={{ ...styles.label }}>배송지</div>
            <div style={{}}>
              <div
                style={{
                  ...styles.inputArea,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: 10,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 5,
                  }}
                >
                  <Text weight={700}>{selectedDelivery?.recipient_name}</Text>
                  {!selectedDelivery?.delivery_address_id ? (
                    selectedDelivery ? <span
                      style={{
                        fontSize: 12,
                        color: '#666666',
                        background: '#EEEEEE',
                        padding: '3px 5px',
                        borderRadius: 3,
                      }}
                    >
                      기본 배송지
                    </span>
                      : <span style={{
                        fontSize: 12,
                        padding: '3px 5px',
                        borderRadius: 3,
                      }}
                      >
                        등록된 기본 배송지가 없습니다. 배송지를 추가해 주세요.
                      </span>
                  ) : null}
                  {
                    selectedDelivery ? <Button
                      type="secondary"
                      style={{
                        fontSize: 12,
                        marginLeft: 10
                      }}
                      onClick={() => setIsOpened(!isOpened)}
                    >
                      배송지 변경
                    </Button>
                      : <Button
                        style={{
                          fontSize: 12,
                          color: '#666666',
                          background: '#EEEEEE',
                          padding: '3px 5px',
                          borderRadius: 3,
                          border: 'none'
                        }}
                        onClick={() => navigate('/mypage/editprofile')}
                      >
                        배송지 추가 및 변경
                      </Button>
                  }
                </div>
                <div
                  style={{
                    display: 'flex',
                    gap: 5,
                    alignItems: 'center',
                  }}
                >
                  <Text size={14}>{selectedDelivery?.recipient_address}</Text>
                  <Text size={14}>
                    {selectedDelivery?.recipient_address_detail}
                  </Text>
                </div>
                <div>
                  <Text size={14}>{selectedDelivery?.recipient_phone}</Text>
                </div>
              </div>
            </div>
          </li>

          <li style={{ ...styles.form, marginBottom: 0 }}>
            {selectedDelivery ? <div style={{ ...styles.label }}>배송메시지</div> : null}
            {selectedDelivery ? <div>
              <div style={{ ...styles.inputArea }}>
                <Select
                  options={DELIVERY_REQUEST}
                  placeholder="배송요청사항을 선택해주세요."
                  value={selectedRequest}
                  style={{ ...styles.input.medium }}
                  onChange={(e) => {
                    onSelect((prev) => ({
                      ...prev,
                      request: e,
                    }));
                    setSelectedRequest(e);
                  }}
                />
              </div>
              <div>
                {selectedRequest === null ? (
                  <Input.TextArea
                    value={selectedDelivery?.request}
                    onChange={(e) =>
                      onSelect((prev) => ({
                        ...prev,
                        request: e.target.value,
                      }))
                    }
                  />
                ) : null}
              </div>
            </div> :
              <div>
              </div>}
          </li>
        </ul>
      </Content>
      {/* !SECTION: 배송지 */}

      {/* SECTION: 배송지 선택 모달 */}
      <ModalLayout
        open={isOpened}
        onCancel={() => setIsOpened(!isOpened)}
        width={500}
        closable
        centered
      >
        <Content maxWidth={'100%'}>
          <Row>
            <Col x={24}>
              <Content padding={0}>
                <Title style={{ marginBottom: 10 }}>배송지 정보</Title>

                <Button
                  type="secondary"
                  style={{ width: '100%', borderRadius: 0 }}
                  onClick={() => onOpen('create', { user_id: user.user_id })}
                >
                  배송지 추가
                </Button>
              </Content>
            </Col>

            <Col x={24}>
              <Content maxWidth={'100%'} padding={0} style={{ marginTop: 30 }}>
                <Radio.Group
                  value={selectedAddress?.delivery_address_id ?? null}
                >
                  {deliveryAddress
                    .filter((address) => address)
                    .map((address) => (
                      <div
                        key={`delivery-address-${address?.delivery_address_id}`}
                        style={{
                          display: 'flex',
                          alignItems: 'baseline',
                          gap: 10,
                        }}
                      >
                        <Radio
                          value={address?.delivery_address_id}
                          onChange={() => setSelectedAddress(address)}
                        />
                        <div style={{ padding: '10px 0px' }}>
                          <Text
                            size={16}
                            weight={700}
                            style={{ webkitLineClamp: 'unset' }}
                          >
                            {address?.recipient_name}
                          </Text>
                          <div
                            style={{
                              display: 'flex',
                              gap: 0,
                              flexDirection: 'column',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 5,
                                alignItems: 'center',
                              }}
                            >
                              <Text
                                size={16}
                                style={{ webkitLineClamp: 'unset' }}
                              >
                                ({address?.recipient_postcode})
                              </Text>
                              <Text
                                size={16}
                                style={{ webkitLineClamp: 'unset' }}
                              >
                                {address?.recipient_address}
                              </Text>
                            </div>
                            <div>
                              <Text
                                size={16}
                                style={{ webkitLineClamp: 'unset' }}
                              >
                                {address?.recipient_address_detail}
                              </Text>
                            </div>
                          </div>
                          <div>
                            <Text size={16}>{address?.recipient_phone}</Text>
                          </div>
                          <div style={{ marginTop: 10, display: 'flex' }}>
                            <button
                              style={{ ...styles.modalButton }}
                              onClick={() => onOpen('update', address)}
                            >
                              수정
                            </button>
                            {address?.delivery_address_id ? (
                              <button
                                style={{ ...styles.modalButton, marginLeft: 5 }}
                                onClick={() =>
                                  onDelete(address?.delivery_address_id)
                                }
                              >
                                삭제
                              </button>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    ))}
                </Radio.Group>
              </Content>
            </Col>

            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                <Button
                  style={{ width: '100%', borderRadius: 0, marginTop: 30 }}
                  onClick={() => {
                    onSelect(selectedAddress);
                    setIsOpened(false);
                  }}
                >
                  변경하기
                </Button>
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>
      {/* !SECTION: 배송지 선택 모달 */}
    </React.Fragment>
  );
  /**!SECTION - Render */
};

export default AddressInfo;
